import * as React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const propTypes = {
  children: PropTypes.node,
  verticalAlign: PropTypes.oneOf(['top', 'middle', 'bottom']),
  textAlign: PropTypes.oneOf(['left', 'center', 'right']),
  textSize: PropTypes.oneOf(['small', 'regular']),
};
const defaultProps = {
  verticalAlign: 'top',
  textAlign: 'left',
  textSize: 'regular',
};

const THead = styled.thead`
  vertical-align: ${({ verticalAlign }) => verticalAlign};
  text-align: ${({ textAlign }) => textAlign};
  font-size: ${({ textSize }) => (textSize === 'small' ? '0.875rem' : '1rem')};
`;

const TableHead = (props) => {
  const {
    children,
    verticalAlign,
    textAlign,
    textSize,
  } = props;

  return (
    <THead
      verticalAlign={verticalAlign}
      textAlign={textAlign}
      textSize={textSize}
    >
      <tr>
        {children}
      </tr>
    </THead>
  );
};

TableHead.propTypes = propTypes;
TableHead.defaultProps = defaultProps;

export default TableHead;
